export default "__VITE_ASSET__C_J3ByxQ__"